import React, { useState } from "react"
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
  Input,
} from "@nextui-org/react"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useNavigate } from "react-router-dom"
import { setLogin } from "../../state/authSlice"
import { useDispatch } from "react-redux"
import { ToastContainer } from "react-toastify"
import { usePost } from "../../api/reactQueryCustomHooks"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "react-toastify/dist/ReactToastify.css" //react toastify css

function Login() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [errors, setErrors] = useState({})
  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  })

  const resetValues = () => {
    setFormData({
      username: "",
      password: "",
    })
  }

  const onSuccessTasks = (data) => {
    navigate(linksUrl.clientMaster.read)
    dispatch(
      setLogin({
        admin: data.admin,
        token: data.accessToken,
        refreshToken: data.refreshToken,
      })
    )
  }

  const { isPending, mutate: login } = usePost({
    url: apiRoute.adminMaster.login,
    queryKey: "auth",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    // Validate the form before submission
    if (validateForm()) {
      // Perform form submission logic here
      login({
        data: {
          username: formData.username,
          password: formData.password,
        },
      })
    } else {
      console.log("Form has errors. Please fix them.")
    }
  }

  const validateForm = () => {
    const newErrors = {}

    // Validate username
    if (formData.username.trim() === "") {
      newErrors.username = "Client Code is required"
    }

    // Validate password
    if (formData.password.trim() === "") {
      newErrors.password = "Password is required"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }
console.log(errors)
  return (
    <div className="flex items-center justify-center items-baseline pt-20  bg-white h-screen">
      <ToastContainer />

      <Card className="max-w-[800px] bg-gradient-to-t from-gray-100 border-1 border-gray-300  to-white shadow-md">
        <CardHeader className="flex justify-center">
          <h1 className="text-xl uppercase font-bold  leading-tight tracking-tight text-blue-700 dark:text-white text-center">
           Admin Login
          </h1>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardBody className="">
            <div className="flex  flex-col gap-4 mx-2">
              <div className="flex flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  type="text"
                  label="USER NAME"
                  placeholder=" "
                  labelPlacement="outside"
                  isRequired
                  //isInvalid={errors?.username}
                  //errorMessage={errors?.username}
                  name="username"
                  variant="bordered"
                  className="bg-white"
                  classNames={{label:"font-semibold text-xs"}}
                  value={formData.username}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  label="PASSWORD"
                  labelPlacement="outside"
                  placeholder="Enter your password"
                  name="password"
                  isRequired
                  classNames={{label:"font-semibold text-xs"}}
                //  isInvalid={errors?.password}
                 // errorMessage={errors?.password}
                  value={formData.password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  variant="bordered"
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                  className="max-w-xs bg-white"
                />
              </div>
            </div>
          </CardBody>
          <CardFooter className="flex justify-center">
            <Button color="primary" type="submit" isLoading={isPending}>
              Login
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  )
}

export default Login
